<template>
    <FilterFlyout :name="$t('results.sorting.sortBy')">
        <div class="row item-container">
            <div class="col-6" v-for="(option, index) in sortOptions" :key="index">
                <button
                    :class="['btn button bordered filter-option-button', { active: selectedOption(option) }]"
                    @click="selectOption(option)"
                >
                    {{ displayLabel(option) }}
                </button>
            </div>
        </div>
    </FilterFlyout>
</template>

<script>
import { useStore, mapGetters } from 'vuex'

// lodash components
import isEmpty from 'lodash/isEmpty'
import find from 'lodash/find'
import capitalize from 'lodash/capitalize'

export default {
    setup() {
        const store = useStore()

        return {
            store,
        }
    },
    computed: {
        ...mapGetters(['sortOptions']),
    },
    methods: {
        displayLabel(option) {
            return option.field && this.$te(option.field) ? this.$t(option.field) : capitalize(option.name)
        },
        activeOption() {
            return find(this.sortOptions, function (option) {
                return option.active
            })
        },
        selectOption: function (option) {
            const activeOption = this.activeOption()

            activeOption.active = false
            option.active = true

            this.trackEvent('event', {
                eventCategory: 'filtering',
                eventAction: 'submit',
                eventLabel: 'offer_type',
            })

            this.$emit('closeSortModal')
        },
        selectedOption(selectOption) {
            const activeOption = this.activeOption()

            return activeOption === selectOption
        },
    },
}
</script>

<style lang="scss">
@import '~scss/mixins/gutter-size';
@import '~scss/mixins/rem';
@import '~scss/settings/responsive';
@import '~scss/settings/variables';

.item-container {
    @include resize-gutter(20px);
    margin-bottom: -12px;

    .button {
        margin-bottom: 12px;
        padding: 15px 10px;
        line-height: inherit;
    }
}
</style>
